import React, {useState} from "react";
import {Avatar, Grid} from "@mui/material";
import CameraswitchIcon from "@mui/icons-material/Cameraswitch";
import Box from "@mui/material/Box";
import {cardNameNormalizer} from "../utils/normalizer";
import {galleryLink} from "../utils/linkMaker";
import {useNavigate} from "react-router";

export default function MtgTile({card: c}) {

    const navigate = useNavigate()
    const [face, setFace] = useState(true);

    return (
        <Grid item xs={2} sm={2} md={2} key={c.id} sx={{position: 'relative'}}>
            {c.card_back_id == null && c.object == 'card' &&
                <Avatar sx={{
                    position: 'absolute',
                    right: 32,
                    top: 80,
                    width: 48,
                    height: 48,
                    background: "#000"
                }}
                        onClick={() => setFace(!face)}>
                    <CameraswitchIcon color="#fff"/>
                </Avatar>
            }
            <Box
                onClick={() => c.object === 'card'
                    ? navigate(`/${c.set}/${c.collector_number}/${cardNameNormalizer(c.name)}`)
                    : navigate(`/sealed/${c.id}`)}
                display="flex"
                component="img"
                alt={c.name}
                src={c.card_back_id != null ? galleryLink(c.object, c.id) : galleryLink(c.object, c.id, face ? 'front' : 'back')}
                sx={{cursor: 'pointer', borderRadius: 3, width: "100%"}}
            />
        </Grid>

    )
}
